












import AE from '../../node_modules/country-flag-icons/3x2/AE.svg';
import AT from '../../node_modules/country-flag-icons/3x2/AT.svg';
import AU from '../../node_modules/country-flag-icons/3x2/AU.svg';
import BE from '../../node_modules/country-flag-icons/3x2/BE.svg';
import BR from '../../node_modules/country-flag-icons/3x2/BR.svg';
import CA from '../../node_modules/country-flag-icons/3x2/CA.svg';
import CH from '../../node_modules/country-flag-icons/3x2/CH.svg';
import DE from '../../node_modules/country-flag-icons/3x2/DE.svg';
import DK from '../../node_modules/country-flag-icons/3x2/DK.svg';
import EC from '../../node_modules/country-flag-icons/3x2/EC.svg';
import EE from '../../node_modules/country-flag-icons/3x2/EE.svg';
import ES from '../../node_modules/country-flag-icons/3x2/ES.svg';
import EU from '../../node_modules/country-flag-icons/3x2/EU.svg';
import FI from '../../node_modules/country-flag-icons/3x2/FI.svg';
import FR from '../../node_modules/country-flag-icons/3x2/FR.svg';
import GB from '../../node_modules/country-flag-icons/3x2/GB.svg';
import GR from '../../node_modules/country-flag-icons/3x2/GR.svg';
import HK from '../../node_modules/country-flag-icons/3x2/HK.svg';
import HR from '../../node_modules/country-flag-icons/3x2/HR.svg';
import ID from '../../node_modules/country-flag-icons/3x2/ID.svg';
import IE from '../../node_modules/country-flag-icons/3x2/IE.svg';
import IT from '../../node_modules/country-flag-icons/3x2/IT.svg';
import JP from '../../node_modules/country-flag-icons/3x2/JP.svg';
import LI from '../../node_modules/country-flag-icons/3x2/LI.svg';
import LT from '../../node_modules/country-flag-icons/3x2/LT.svg';
import LU from '../../node_modules/country-flag-icons/3x2/LU.svg';
import LV from '../../node_modules/country-flag-icons/3x2/LV.svg';
import MT from '../../node_modules/country-flag-icons/3x2/MT.svg';
import MX from '../../node_modules/country-flag-icons/3x2/MX.svg';
import NL from '../../node_modules/country-flag-icons/3x2/NL.svg';
import NO from '../../node_modules/country-flag-icons/3x2/NO.svg';
import NZ from '../../node_modules/country-flag-icons/3x2/NZ.svg';
import PL from '../../node_modules/country-flag-icons/3x2/PL.svg';
import PT from '../../node_modules/country-flag-icons/3x2/PT.svg';
import RO from '../../node_modules/country-flag-icons/3x2/RO.svg';
import RU from '../../node_modules/country-flag-icons/3x2/RU.svg';
import SE from '../../node_modules/country-flag-icons/3x2/SE.svg';
import SI from '../../node_modules/country-flag-icons/3x2/SI.svg';
import SK from '../../node_modules/country-flag-icons/3x2/SK.svg';
import SV from '../../node_modules/country-flag-icons/3x2/SV.svg';
import TH from '../../node_modules/country-flag-icons/3x2/TH.svg';
import TR from '../../node_modules/country-flag-icons/3x2/TR.svg';
import US from '../../node_modules/country-flag-icons/3x2/US.svg';
import VN from '../../node_modules/country-flag-icons/3x2/VN.svg';

const SUPPORTED_FLAG_ASSETS = {
    AE,
    AT,
    AU,
    BE,
    BR,
    CA,
    CH,
    DE,
    DK,
    EC,
    EE,
    ES,
    EU,
    FI,
    FR,
    GB,
    GR,
    HK,
    HR,
    ID,
    IE,
    IT,
    JP,
    LI,
    LT,
    LU,
    LV,
    MT,
    MX,
    NL,
    NO,
    NZ,
    PL,
    PT,
    RO,
    RU,
    SE,
    SI,
    SK,
    SV,
    TH,
    TR,
    US,
    VN
};


const FLAGS = new Map(Object.entries(SUPPORTED_FLAG_ASSETS));

const getFlagUrl = (countryCode) => {
    if (typeof countryCode !== 'string') return null;

    const normalizedCode = countryCode.trim().toUpperCase();
    return FLAGS.get(normalizedCode) || null;
};

export default getFlagUrl;
